import React from "react";
import { InfiniteList } from "../../../../../common/components";
import { translate } from "../../../../../common/providers";
import ReqRow from "../req-row/ReqRow";
import styles from "./ReqList.module.css";
import ReqListEmptyState from "./ReqListEmptyState";
import ReqListLoader from "./ReqListLoader";

export default function ReqList({
	totalRequirementsInProject,
	totalDeletedRequirementsInProject,
	hasMore = false,
	isLoadingReqs,
	totalElements = 0,
	requirements = [],
	onLoadMore,
	onSelectRequirement,
	selectedRequirement,
	selectedTab,
	isActiveFilter,
}) {
	const isRowLoaded = ({ index }) => !hasMore || index < requirements.length;
	const rowRenderer = ({ key, index, style }) => {
		const { id, clientRef, content, generatedByAI, versionStatus } = requirements[index];
		return (
			<ReqRow
				key={key}
				clientRef={clientRef}
				content={content}
				generatedByAI={generatedByAI}
				id={id}
				selected={selectedRequirement && selectedRequirement.id === id}
				style={style}
				versionStatus={versionStatus}
				onClick={() => onSelectRequirement(id)}
			/>
		);
	};
	const noRowsRenderer = () =>
		requirements.length === 0 && isLoadingReqs ? <ReqListLoader /> : <ReqListEmptyState />;
	const handleLoadMore = () => onLoadMore();
	return (
		<div className={styles.req_list}>
			<div className={styles.req_list__counter}>
				{(isActiveFilter &&
					translate("requirement-matrix.req-list.filtered-result-counter", {
						totalElements,
						totalRequirementsInProject:
							selectedTab === "active" ? totalRequirementsInProject : totalDeletedRequirementsInProject,
					})) ||
					translate("requirement-matrix.req-list.result-counter", {
						totalElements,
					})}
			</div>
			<InfiniteList
				className={styles.req_list__infinite_list}
				currentTotalElements={requirements.length}
				height={1080}
				isRowLoaded={isRowLoaded}
				loadMoreRows={handleLoadMore}
				noRowsRenderer={noRowsRenderer}
				rowHeight={80}
				rowRenderer={rowRenderer}
				threshold={45}
				totalElements={totalElements}
				width={1920}
			/>
		</div>
	);
}
